export const supportStyles = { fontFamily: "Arial", fontSize: "14px" };
export const anaptyssStyles = { fontFamily: "Arial", fontSize: "14px" };
export const detailStyles = { fontFamily: "Manrope", fontSize: "14px" };
export const boxStyles = { py: 5, px: 3, backgroundColor: "#0F1012", color: "#F7F7F7", paddingTop: 3, paddingBottom: 3};
export const bottomStyles = { boxShadow: 6 };
export const logoWrapStyles = { ml: -1.5, mb: -1 }


